import { Box } from "@mui/material";

const ICON_BADGE_BG = "#F4F6F8";
const ICON_BADGE_COLOR = "#64748B";

function IconBadge({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: 1.5,
        bgcolor: ICON_BADGE_BG,
        color: ICON_BADGE_COLOR,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {children}
    </Box>
  );
}

export { IconBadge };
